import { message } from 'antd';
import { queryReceiptInfo } from '@api/finance/receipt';
import PageAdd from './PageAdd';

class PageEdit extends PageAdd {
  componentDidMount() {
    this.getReceipt();
  }

  getReceipt = () => {
    queryReceiptInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default PageEdit;



// WEBPACK FOOTER //
// ./src/components/finance/receipt/PageEdit.js